import { lazy, Suspense } from 'react';
import { isPulseEnabled } from '../../../../pulse/runtime';
import type { DataSourcePulseObserverProps } from './DataSourcePulseObserver';

const DataSourcePulseObserver = lazy(() => import('./DataSourcePulseObserver'));

/**
 * The gate the query nodes render in place of the Pulse lifecycle hook. isPulseEnabled() is false
 * in the deployed matrix runner, so the lazy observer — and the pulse floor core it imports — never
 * loads there; in builder/preview it resolves true and the observer mounts. Nodes import THIS file
 * (which pulls in only the tiny runtime gate), never the observer directly, so the pulse core stays
 * out of the runner bundle.
 */
export function DataSourcePulseObserverGate(props: DataSourcePulseObserverProps) {
  if (!isPulseEnabled()) return null;

  return (
    <Suspense fallback={null}>
      <DataSourcePulseObserver {...props} />
    </Suspense>
  );
}
